<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import TestimonialCard from "@/components/testimonials/TestimonialCard.vue";
import appConfig from "@/app.config";
export default {
  components: {
    Swiper,
    SwiperSlide,
    TestimonialCard,
  },
//   watch: {
//   // props: {
//   //   // the callback will be called immediately after the start of the observation
//   //   title: String,
//   //   testimonials: Array,
//   //   immediate: true, 
//   //   handler (newVal, oldVal) {
//   //         console.log('Prop changed: ', newVal, ' | was: ', oldVal)
//   //   }
//   // }
// },
  props: {
    title: String,
    testimonials: Array,
  },
  watch: { 
    testimonials: function() { // watch it
      this.defaultLoad()
    }
  },
  
  data() {
    return {
      assetsPath: appConfig.assetsPath,
      testimonialsData: [],
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 40,
        centeredSlides: true,
        width: 1150,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 40,
            width: 1150,
          },
          500: {
            slidesPerView: 1,
            spaceBetween: 30,
            width: 354,
          },
          400: {
            slidesPerView: 1,
            spaceBetween: 20,
            width: 320,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
            width: 300,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  created() {
    this.defaultLoad();
  },
  updated() {
    this.defaultLoad();
  },
  methods: {
    defaultLoad() {
      if (this.testimonials) {
        this.testimonialsData = this.testimonials
      } else {
        this.testimonialsData = this.$t('testimonials.testimonialsData');
      }
    }
  }
};
</script>

<template>
  <div :class="$style.testimonials" class="w-100 d-inline-block testimonials-global"
    :style="{backgroundImage: 'url('+this.assetsPath+'images/panda-foot-pattern@2x.png)'}"
  >
    <h2 class="heading-2 text-center ">
      <span v-if="title">{{title}}</span>
      <span v-else>{{ $t("testimonials.title")}}</span>
    </h2>
    <div :class="$style.slider">
      <Swiper class="swiper" :options="swiperOption">
        <SwiperSlide
          v-for="(testimonial, index) in testimonialsData"
          :key="index"
          :class="$style.cardWidth"
        >
          <TestimonialCard :testimonial="testimonial" />
        </SwiperSlide>
        <div slot="button-prev" class="swiper-button-prev" :class="$style.navigation">
          <img :src="this.assetsPath+'images/icons/slider-arrow.svg'" class="svgIcon"  />
        </div>
        <div slot="button-next" class="swiper-button-next" :class="$style.navigation">
          <img :src="this.assetsPath+'images/icons/slider-arrow.svg'" class="svgIcon" />
        </div>
      </Swiper>
    </div>
  </div>
</template>

<style lang="scss" module>
@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";
.testimonials {
  padding: 30px 0 30px;
  background-color: $bg-light-skye-blue;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  h2 {
    margin-bottom: 40px;
  }  
}
@media only screen and (max-width: 767px) {
  .testimonials{
    .slider{
      padding-left: 0;
    }
  }
  .navigation{
    display: none;
  }
}

</style>
